/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/SendPatientMessage/Recipients/Empty"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="No recipients found for the selected patient"
/>
</div>
{children}
</React.Fragment>)
}